import { css } from 'styled-components';

// 44px is the smallest comfortable touch target, and most of this app's controls are built for a
// cursor: tab strips land around 40px, inline row buttons and icon buttons around 32px.
//
// Applied below the breakpoint only, so nothing on a desktop changes size. Not fixed on the shared
// `Button` — that would resize every button in the app, which is a far wider change than any
// mobile ticket should make — so call sites opt in.
//
// `mobileTouchTarget` raises the height, which suits anything already full-width or text-sized.
// `mobileTouchExpand` is for everything whose drawn size belongs to the design — icon buttons with
// their own outline, a text link in a header — and enlarges the area without enlarging the box.
//
// Do NOT pad a wrapper around the control instead. The hit area has to sit on the element that
// carries the click handler, and a wrapper usually isn't it — `Menu.Trigger` puts `onClick` on the
// button through `Slot`, so a padded wrapper leaves the ring around it dead while measuring 44px.
export const mobileTouchTarget = css`
  @media ${({ theme }) => theme.devices.mobile} {
    min-height: 44px;
  }
`;

// A 44px area without a 44px box: a centred pseudo-element takes the tap. `position: relative`
// also lifts the control above its static siblings, which is what keeps its area winning where it
// overlaps neighbouring text.
export const mobileTouchExpand = css`
  @media ${({ theme }) => theme.devices.mobile} {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: max(100%, 44px);
      height: max(100%, 44px);
    }
  }
`;
